// routes
import { paths } from 'src/routes/paths';

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) return false;
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  let expiredTimer;
  const currentTime = Date.now();

  // const timeLeft = 10000;
  const timeLeft = exp * 1000 - currentTime;
  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    clearTimeout(expiredTimer);
    setSessionToken(null);
    window.location.href = paths.error.tokenExpired;
  }, timeLeft);
};

export const setSessionToken = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    const { exp } = jwtDecode(accessToken);
    tokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
  }
};

export const getSessionToken = () => localStorage.getItem('accessToken');
